// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpecialChanceDescription_rule__z4uRd {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  flex-direction: column;
  background: var(
    --BG4,
    linear-gradient(192deg, #384b70 -18.2%, #015551 90.82%)
  );
  min-height: 100vh;
}
.SpecialChanceDescription_rule-modal__IBS4d {
  padding: unset !important;
  max-width: unset !important;
  top: 0 !important;
}

.SpecialChanceDescription_modal-container__1nwI8 {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 24px 24px;
  background-color: white;
  border-radius: 16px;
}

.SpecialChanceDescription_close-icon__-NW8N {
  margin-bottom: 20px;
  position: absolute;
  top: 16px;
  left: 24px;
}

.SpecialChanceDescription_rule-modal-overlay__jtpDp {
  opacity: 0;
  display: none;
}

.SpecialChanceDescription_modal-list__g8OSi {
  list-style-type: disc;
  width: 100%;
  overflow: hidden;
  padding-right: 24px;
  padding-left: 0px;
  margin-top: 20px;
  margin-bottom: 20px;
  color: #384b70;
  font-size: 14px;
  font-weight: 400;
}

.SpecialChanceDescription_inner__Y22\\+M {
  padding: 0 24px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.SpecialChanceDescription_items__0ZCbx {
  border-radius: 0px 0px 16px 0px;
  backdrop-filter: blur(25px);
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
}
.SpecialChanceDescription_items__0ZCbx li {
  color: #fcfaee;
  text-align: right;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 166.667% */
  list-style: disc;
}

@media screen and (min-width: 1000px) {
  .SpecialChanceDescription_rule__z4uRd {
    min-height: unset;
    border-radius: 18px;
    padding-bottom: 32px;
  }
  .SpecialChanceDescription_inner__Y22\\+M {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 1200px;
    width: 100%;
  }
  .SpecialChanceDescription_rule-modal__IBS4d {
    max-width: 650px !important;
    top: 25vh !important;
  }
  .SpecialChanceDescription_items__0ZCbx li {
    font-size: 14px;
  }

  .SpecialChanceDescription_inner__Y22\\+M {
    background-image: unset;
  }
  .SpecialChanceDescription_rule-modal-overlay__jtpDp {
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Modals/specialChanceDescription/SpecialChanceDescription.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB;;;GAGC;EACD,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;EAEvB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAE/B,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,2BAA2B;IAC3B,oBAAoB;EACtB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".rule {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  flex-direction: column;\n  background: var(\n    --BG4,\n    linear-gradient(192deg, #384b70 -18.2%, #015551 90.82%)\n  );\n  min-height: 100vh;\n}\n.rule-modal {\n  padding: unset !important;\n  max-width: unset !important;\n  top: 0 !important;\n}\n\n.modal-container {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  padding: 24px 24px;\n  background-color: white;\n  border-radius: 16px;\n}\n\n.close-icon {\n  margin-bottom: 20px;\n  position: absolute;\n  top: 16px;\n  left: 24px;\n}\n\n.rule-modal-overlay {\n  opacity: 0;\n  display: none;\n}\n\n.modal-list {\n  list-style-type: disc;\n  width: 100%;\n  overflow: hidden;\n  padding-right: 24px;\n  padding-left: 0px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  color: #384b70;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.inner {\n  padding: 0 24px;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.items {\n  border-radius: 0px 0px 16px 0px;\n  -webkit-backdrop-filter: blur(25px);\n  backdrop-filter: blur(25px);\n  padding: 8px 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 4px;\n}\n.items li {\n  color: #fcfaee;\n  text-align: right;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 166.667% */\n  list-style: disc;\n}\n\n@media screen and (min-width: 1000px) {\n  .rule {\n    min-height: unset;\n    border-radius: 18px;\n    padding-bottom: 32px;\n  }\n  .inner {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-width: 1200px;\n    width: 100%;\n  }\n  .rule-modal {\n    max-width: 650px !important;\n    top: 25vh !important;\n  }\n  .items li {\n    font-size: 14px;\n  }\n\n  .inner {\n    background-image: unset;\n  }\n  .rule-modal-overlay {\n    opacity: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rule": `SpecialChanceDescription_rule__z4uRd`,
	"rule-modal": `SpecialChanceDescription_rule-modal__IBS4d`,
	"modal-container": `SpecialChanceDescription_modal-container__1nwI8`,
	"close-icon": `SpecialChanceDescription_close-icon__-NW8N`,
	"rule-modal-overlay": `SpecialChanceDescription_rule-modal-overlay__jtpDp`,
	"modal-list": `SpecialChanceDescription_modal-list__g8OSi`,
	"inner": `SpecialChanceDescription_inner__Y22+M`,
	"items": `SpecialChanceDescription_items__0ZCbx`
};
export default ___CSS_LOADER_EXPORT___;
